module.exports = __webpack_public_path__ + "static/012.thumb-0c8bf484d0d5c5af267f4b820b72c7bf.jpg";